import { Stack, useTheme } from "@mui/material";
import { MainScore } from "./MainScore";
import { ScoreValue } from "src/api/client-api/post/scoreSchema";
import { ScoreComparison } from "../ScoreComparison";
import { useTranslation } from "react-i18next";
import { ScoreImprovement } from "src/types";

type ScoreSummaryProps = {
    score: ScoreValue | undefined;
    prevScoreValue: ScoreValue | undefined;
    prevCampaign: string | undefined;
    referenceScore: number | undefined;

    precision: number;
    unit: string | undefined;
    improvement: ScoreImprovement;
};
export const ScoreSummary = (props: ScoreSummaryProps) => {
    const theme = useTheme();
    const { t } = useTranslation();

    const { score = null, unit, precision, prevScoreValue, prevCampaign, referenceScore, improvement } = props;

    const isPrevScoreValid = prevScoreValue !== undefined && prevScoreValue !== null;
    return (
        <Stack gap={theme.spacing(1)}>
            <MainScore
                score={{
                    value: score,
                    unit: unit,
                    precision: precision,
                }}
                referenceScore={referenceScore}
            />

            {isPrevScoreValid && (
                <ScoreComparison
                    improvement={improvement}
                    scoreValueToCompare={score}
                    referenceScoreValue={prevScoreValue}
                    unit={unit}
                    reportName={prevCampaign ?? ""}
                    precision={precision}
                />
            )}

            {referenceScore && (
                <ScoreComparison
                    improvement={improvement}
                    scoreValueToCompare={score}
                    referenceScoreValue={referenceScore}
                    unit={unit}
                    reportName={t("score_reference.the_reference")}
                    precision={precision}
                />
            )}
        </Stack>
    );
};
